<script>
import Checkbox from '@/components/Checkbox'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import VueUtils from '@/utils/vueUtils'
import DOMUtils from '@/utils/DOMUtils'
import asyncUtils from '@/utils/asyncUtils'

export default
{
    name: 'editable-table',

    props:
    {
        labels: { type: Object, default: () => ({}) },
        
        // bound to v-model.
        value: { type: Array, default: () => ([[]]) }
    },

    created ()
    {
        this.values = this.value
    },

    render () 
    {
        return (
            <div class='editable-table'>
                <table>
                    <thead ref='tableHead'>
                        <div class='head-shadow' ref='tableHeadShadow' />
                        <tr>
                        {
                            Object.values(this.tableLabels).map(label =>
                            {
                                return <th><div class='cell'>{label.name.toString()}</div></th>
                            })
                        }
                        </tr>
                    </thead>
                    <tbody>
                    {
                        this.displayedValues.map((row, rowIndex) =>
                        {
                            const ref = 'row' + rowIndex

                            return (
                                <tr tabindex='-1' class='row' ref={ref} on-click={e => this.onRowClicked(e, this.$refs[ref])}>
                                {
                                    row.map((rowElement, rowElementIndex) =>
                                    {
                                        const label = Object.values(this.tableLabels)[rowElementIndex]
                                        let content

                                        if (label.type == 'input')
                                        {                                                
                                            content = <floating-label-text-input v-model={this.values[rowIndex][rowElementIndex]}
                                                placeholder={label.placeholder} autocomplete={label.autocomplete} placeholder-disappear-on-text={true} />
                                        }
                                        else if (rowElement == undefined || rowElement == null) content = DOMUtils.nbsp
                                        else if (VueUtils.isVNode(rowElement)) content = rowElement
                                        else if (typeof rowElement == 'boolean') content = <Checkbox v-model={this.values[rowIndex][rowElementIndex]} />
                                        else content = rowElement.toString()

                                        return <td><div class='cell'>{content}</div></td>
                                    })
                                }
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    },

    data () 
    {
        return {
            initialValuesJSON: null,
            values: [],
            displayedValues: [],
            initCount: 0
        }
    },

    mounted ()
    {
        const headShadow = this.$refs.tableHeadShadow
        headShadow.style.width = this.$el.getBoundingClientRect().width + 'px'
        headShadow.style.height = this.$refs.tableHead.getBoundingClientRect().height + 'px'
    },

    watch:
    {
        value ()
        {
            this.values = this.value
        },

        async values ()
        {
            this.$emit('input', this.values)
        },
    },

    computed:
    {
        JSONValues ()
        {
            return JSON.stringify(this.values.map(this.getRowValues))
        },

        hasBeenModified ()
        {
            return this.initialValuesJSON != this.JSONValues
        },

        tableLabels ()
        {
            const labels = {}

            for (let pair of Object.entries(this.labels))
            {
                var value = pair[1]
                if (typeof value == 'string') value = {name: value}

                labels[pair[0]] = value
            }

            return labels
        }
    },

    methods:
    {
        addRow (row)
        {
            this.values.push(Object.keys(this.tableLabels).map(col => row[col]))
        },

        onRowClicked (event, row)
        {
            // this.$el.querySelectorAll('.row').forEach(r => r.classList.remove('active'))
            // row.classList.add('active')
        },

        getRowValues (row)
        {
            return row.filter(val => !VueUtils.isVNode(val))
        },

        getLabelledRow (rowIndex)
        {
            const row = this.getRowValues(this.values[rowIndex])

            const labelled = {}
            for (const i in row)
            {
                labelled[Object.keys(this.tableLabels)[i]] = row[i]
            }

            return labelled
        },

        getModifiedRows ()
        {
            const modifiedRows = []
            const initialValues = JSON.parse(this.initialValuesJSON)

            for (const i in this.values)
            {
                const row = this.getRowValues(this.values[i])
                const initialRow = this.getRowValues(initialValues[i])
                const hasChanged = JSON.stringify(row) != JSON.stringify(initialRow)

                if (!hasChanged) continue

                modifiedRows.push(row)
            }

            return modifiedRows
        },

        async initialized ()
        {
            this.initialValuesJSON = this.JSONValues

            if (this.initCount > 0)
            {
                this.displayedValues = this.values.slice(0)
            }
            else
            {
                for (let i = 0; i < this.values.length; i++)
                {
                    this.displayedValues.push(this.values[i])

                    const sleep = i > 10 ? 200 : 20
                    if (sleep > 20)
                    {
                        this.$nextTick(() => DOMUtils.animateCSS(this.$refs['row' + i], 'fadeIn', sleep * 1.5))
                        await asyncUtils.sleep(sleep)
                    }
                }
            }

            this.initCount += 1;
        },

        clearTable ()
        {
            this.values = []
            this.displayedValues = []
            this.initialValuesJSON = null
        }
    },

    components:
    {
        Checkbox,
        FloatingLabelTextInput
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.editable-table
{
    background-color: var(--theme-content-background-color);
    overflow: auto;
    border-radius: 8px;
    -webkit-overflow-scrolling: touch;
    
    &::-webkit-scrollbar
    {
        background-color: inherit;
        border-radius: inherit;
    }

    table
    {
        width: 100%;

        thead
        {
            border-radius: inherit;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;

            .head-shadow
            {
                position: absolute;
                box-shadow: var(--theme-box-shadow-sharp);
                border-radius: inherit;
            }

            th
            {
                position: sticky;
                top: 0;
                background-color: var(--theme-content-background-color);
                vertical-align: middle;
                z-index: 2;

                .cell
                {
                    .OnDesktop({ margin: 20px; });
                }
            }
        }

        .row
        {
            &:hover
            {
                background-color: var(--theme-border-color-mega-light);
            }

            &.active
            {
                background-color: var(--theme-border-color-extra-light);
            }
        }

        .cell
        {
            font-size: 80%;
            margin: 12px 20px;

            .checkbox
            {
                padding: 10px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/EditableTable.vue